import { render, staticRenderFns } from "./BookingDetails.vue?vue&type=template&id=6b6ad4c0&scoped=true"
import script from "./BookingDetails.vue?vue&type=script&lang=js"
export * from "./BookingDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingDetails.vue?vue&type=style&index=0&id=6b6ad4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ad4c0",
  null
  
)

export default component.exports